import { render, staticRenderFns } from "./editPlayerTalentSend.vue?vue&type=template&id=49967f76&scoped=true&"
import script from "./editPlayerTalentSend.vue?vue&type=script&lang=js&"
export * from "./editPlayerTalentSend.vue?vue&type=script&lang=js&"
import style0 from "./editPlayerTalentSend.vue?vue&type=style&index=0&id=49967f76&lang=stylus&scoped=true&"
import style1 from "./editPlayerTalentSend.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./editPlayerTalentSend.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49967f76",
  null
  
)

export default component.exports